import React, { useEffect } from 'react';
import { captureUtmFromUrl } from '../utils/utm';

export const UtmProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useEffect(() => {
    captureUtmFromUrl();
  }, []);

  return <>{children}</>;
};
